import React, {useState, useContext} from 'react'
import styled from '@emotion/styled';
import {color} from '../../constants';
import frequencyOptions from './frequency-options';
import {updatePreferences, unsubscribe} from '../../api';
import { PageContext } from '../PocketHitsShared/page-context';
import { PreferencesContext } from '../PocketHitsShared/preferences-context';
import { getHeaderCopy } from './helpers'
import { RADIO_GROUP_NAME, STATUS_SUBSCRIBED, STATUS_UNSUBSCRIBED } from './constants'

const PocketHitsPreferences = styled.div`
  font-family: "Arial", "sans-serif";
  font-size: 13px;
`

const Header = styled.h1`
  font-size: 18px;
  font-weight: 400;
  margin: 35px 0px 15px 0px;
  padding-bottom: 1em;
  border-bottom: solid 1px #cacaca; // legacy gray
`

const RadioContainer = styled.div`
  margin-bottom: 2em;
`

const RadioLabel = styled.label`
  position: relative !important;
`
const InputChoice = ({id, value, label, isSelected, handleClick}) => {
  return (
      <div>
        <input type="radio" id={id}
               name={RADIO_GROUP_NAME} value={value} checked={isSelected} onChange={handleClick}/>
        <RadioLabel htmlFor={id}>{label}</RadioLabel>
      </div>
  )
}

const UnsubscribeLink = styled.a`
  color: #478f8f; // legacy teal
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

const Submit = styled.button`
  background-color: ${color.coral80};
  color: ${color.white100};
  height: 40px;
  border-radius: 4px;
  padding: 11px 24px 13px;
  font-size: 14px;
  line-height: normal;
  transition: all .25s ease-out;;
  box-sizing: border-box;
  border: solid 1px ${color.coral80};
  margin-bottom: 1em;
  
  &:hover, &:active, &:focus {
    background-color: ${color.oneoff.pocketHitsSubmitHover};
    border: solid 1px ${color.oneoff.pocketHitsSubmitHover};
    cursor: pointer;
    transition-duration: 200ms;
  }
`

const updateSubscription = (frequency, uuid, frequencyUpdateInFlight, updateFrequencyNetworkStatus, updateSubscribedStatus, updateUserMessage, signedParams, updateSignedParams) => e => {
  e.preventDefault();

  if (!frequency || frequencyUpdateInFlight) return;

  updateFrequencyNetworkStatus(true);

  updatePreferences(uuid, {
    frequency,
    ...signedParams
  }, (message, refreshedSignedParams) => {
    updateUserMessage(message);
    updateSignedParams(refreshedSignedParams); // check with Kaiser
    updateSubscribedStatus(STATUS_SUBSCRIBED);
  }, message => {
    updateUserMessage(message)
  }, () => updateFrequencyNetworkStatus(false));
}

const SubscriptionStatus = styled.p`
  font-style: italic;
`

const cancelSubscription = (status, onUpdateStatus, uuid, updateSubscriptionNetworkStatus, updateUserMessage) => e => {
  e.preventDefault();

  if (status === STATUS_UNSUBSCRIBED) {
    updateUserMessage({
      success: true,
      message: 'You are already unsubscribed',
    });
    return;
  }

  updateSubscriptionNetworkStatus(true);

  unsubscribe(uuid, (successMessage) => {
    updateUserMessage(successMessage);
    onUpdateStatus(STATUS_UNSUBSCRIBED);
  }, (errorMessage) => {
    updateUserMessage(errorMessage);
  }, () => updateSubscriptionNetworkStatus(false))
}

const SuccessMessage = styled.p`
  color: ${color.mint100};
`

const ErrorMessage = styled.p`
  color: ${color.coral80};
`

const Message = ({outcome}) => {
  if (outcome.success) {
    return (<SuccessMessage>{outcome.message}</SuccessMessage>);
  }
  return (<ErrorMessage>{outcome.message}</ErrorMessage>)
}



export default () => {
  const { subscription, uuid, updateFrequency, frequencyUpdateInFlight, updateFrequencyNetworkStatus, updateSubscribedStatus, subscriptionUpdateInFlight, updateSubscriptionNetworkStatus} = useContext(PreferencesContext);
  const { action, signedParams, updateSignedParams } = useContext(PageContext);

  const [statusMessage, updateStatus] = useState(null);

  const submitClickHandler = (e) => updateSubscription(subscription.frequency, uuid, frequencyUpdateInFlight, updateFrequencyNetworkStatus, updateSubscribedStatus, updateStatus, signedParams, updateSignedParams)(e);

  const cancelClickHandler = (e) => cancelSubscription(subscription.status, updateSubscribedStatus, uuid, updateSubscriptionNetworkStatus, updateStatus)(e);

  return (
      <PocketHitsPreferences>
        <Header>{getHeaderCopy(action)}</Header>
        <form
            onSubmit={submitClickHandler}>
          <p>I’d like to receive Pocket Hits:</p>
          <RadioContainer>
            {frequencyOptions.map(f =>
                <InputChoice
                    id={f.id}
                    value={f.value}
                    label={f.label}
                    isSelected={subscription.frequency === f.value}
                    handleClick={() => updateFrequency(f.value)}
                    key={f.value}/>)}
          </RadioContainer>
          <div>
            {statusMessage && <Message outcome={statusMessage}/>}
            <Submit type="submit"
                    disabled={frequencyUpdateInFlight}>{frequencyUpdateInFlight ? "Updating..." : "Save changes"}</Submit>
          </div>
        </form>
        {subscription.status === STATUS_SUBSCRIBED
          ? <UnsubscribeLink
            onClick={cancelClickHandler}>{subscriptionUpdateInFlight ? "Updating subscription..." : "Unsubscribe from Pocket Hits"}</UnsubscribeLink>
          : <SubscriptionStatus>Currently unsubscribed</SubscriptionStatus>}
      </PocketHitsPreferences>
  )
}
